import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModifierCodeService } from 'src/app/services/core/modifier-code/modifier-code.service';
import { PrimaryDiagnosisService } from 'src/app/services/core/primary-diagnosis/primary-diagnosis.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()
@Component({
  selector: 'app-add-modifier-code',
  templateUrl: './add-modifier-code.component.html',
  styleUrls: ['./add-modifier-code.component.css']
})
export class AddModifierCodeComponent implements OnInit {
  modifierCodeForm!: FormGroup;
  submitted = false;
  modifierCodeId: any;

  @Input() modifierCode: any;
  @Input() source: any;
  @Output() onSaveModifierCode = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modifierCodeService: ModifierCodeService,
  ) { }

  ngOnInit(): void {
    if (this.source === 'modal' && this.modifierCode) {
      this.modifierCodeId = this.modifierCode.id;
      this.getById();
    } else {
      this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
        if (param && param['id']) {
          this.modifierCodeId = param['id'];
          this.getById();
        }
      });
    }

    this.modifierCodeForm = this.fb.group({
      title: ["", Validators.required],
      code: ["", Validators.required],
      isActive: [true, Validators.required],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.modifierCodeForm.invalid) return;
    const payload = this.modifierCodeForm.value;

    this.modifierCodeService
      .save(this.modifierCodeId, payload)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
      if (data) {
        if (this.source === 'modal') {
          this.onSaveModifierCode.emit(data);
        } else {
          this.router.navigateByUrl('/billing/modifier-codes');
        }
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "OK");
    }
    )
  }

  getById() {
    this.modifierCodeService
      .getById(this.modifierCodeId)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.modifierCodeForm.patchValue(data)
        }
      });
  }

  get form() {
    return this.modifierCodeForm.controls;
  }
}
